import { render, staticRenderFns } from "./commissions.component.vue?vue&type=template&id=63de8d5f&"
import script from "./commissions.component.vue?vue&type=script&lang=js&"
export * from "./commissions.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports